import React, { useContext, useState } from "react";

import styles from "./UserDashboard.module.css";
import { UserContext } from "../../context/UserContext";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FirebaseApp } from "../../services/firebaseConfig";
import Button from "../../components/common/Button";

export default function GroupPayment() {
  const { userData } = useContext(UserContext);
  const [loadingType, setLoadingType] = useState(null);
  const [error, setError] = useState(null);
  const [showPixModal, setShowPixModal] = useState(false);

  const functions = getFunctions(FirebaseApp, "us-central1");
  const createCheckoutSession = httpsCallable(
    functions,
    "createCheckoutSession"
  );

  async function startStripeCheckout(productType) {
    if (!userData) {
      window.location.href = "/login";
      return;
    }

    setLoadingType(productType);
    setError(null);

    try {
      const res = await createCheckoutSession({
        productType,
        currency: "BRL",
      });

      window.location.href = res.data.url;
    } catch (err) {
      console.error(err);
      setError("Erro ao iniciar o pagamento. Tente novamente.");
      setLoadingType(null);
    }
  }

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <h1>Pagamento do Grupo de Discussão</h1>

        <p className={styles.subtitle}>
          Escolha a forma de participação no Grupo de Discussão em Terapia
          Baseada em Processos
        </p>

        {/* ================= PLANO MENSAL ================= */}
        <div className={`${styles.card} ${styles.featured || ""}`}>
          <h3>Plano mensal</h3>

          <p className={styles.description}>
            Pagamento mensal com acesso imediato ao grupo durante todo o
            período.
          </p>

          <p className={styles.price}>
            R$ 50,00 <span className={styles.period}>/ mês</span>
          </p>

          <p className={styles.muted}>
            Duração prevista do grupo: 3 meses. A cobrança é mensal e será
            encerrada automaticamente ao final do período.
          </p>

          <Button
            disabled={loadingType === "groupMonthly"}
            onClick={() => startStripeCheckout("groupMonthly")}
          >
            {loadingType === "groupMonthly"
              ? "Redirecionando..."
              : "Assinar plano mensal"}
          </Button>
        </div>

        {/* ================= PAGAMENTO ÚNICO ================= */}
        <div className={styles.card}>
          <h3>Pagamento único no cartão</h3>

          <p className={styles.description}>
            Pagamento à vista com acesso imediato ao grupo durante todo o
            período.
          </p>

          <p className={styles.price}>R$ 150,00</p>

          <p className={styles.muted}>
            Cobrança única no cartão de crédito. Acesso válido por 3 meses.
          </p>

          <Button
            disabled={loadingType === "groupOneTime"}
            onClick={() => startStripeCheckout("groupOneTime")}
          >
            {loadingType === "groupOneTime"
              ? "Redirecionando..."
              : "Pagar à vista no cartão"}
          </Button>
        </div>

        {/* ================= PIX MANUAL ================= */}
        <div className={styles.card}>
          <h3>Pagamento via PIX</h3>

          <p className={styles.description}>
            Pagamento manual via PIX da empresa, com confirmação posterior.
          </p>

          <p className={styles.price}>R$ 150,00</p>

          <p className={styles.muted}>
            Após o pagamento, o acesso será liberado manualmente após
            verificação.
          </p>

          <Button
            className={styles.secondaryBtn}
            onClick={() => setShowPixModal(true)}
          >
            Ver instruções de pagamento via PIX
          </Button>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <p className={styles.muted} style={{ marginTop: 24 }}>
          Pagamentos com cartão são processados de forma segura pelo Stripe.
        </p>
      </div>

      {/* ================= MODAL PIX ================= */}
      {showPixModal && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalCard}>
            <h3>Pagamento via PIX</h3>

            <p className={styles.muted}>
              Para realizar o pagamento via PIX, utilize os dados abaixo.
            </p>

            <div className={styles.pixBox}>
              <p>
                <strong>Valor:</strong> R$ 150,00
              </p>
              <p>
                <strong>Chave PIX:</strong> 63.304.502/0001-26
              </p>
              <p className={styles.muted}>
                Após o pagamento, o acesso ao grupo será liberado manualmente
                após a confirmação. Para avisar sobre pagamento e
                esclarescimento de dúvidas entrar em contato pelo whatsapp: (61)
                99249-2842
              </p>
            </div>

            <div className={styles.meetingActions}>
              <Button
                className={styles.secondaryBtn}
                onClick={() => setShowPixModal(false)}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
